import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './ga';

export function useGaPageView() {
  const { pathname, search } = useLocation();
  const lastPathRef = useRef('');

  useEffect(() => {
    const pageKey = `${pathname}${search}`;
    if (lastPathRef.current === pageKey) {
      return;
    }
    lastPathRef.current = pageKey;
    trackPageView(pathname, search);
  }, [pathname, search]);
}
